const LiveUnload = ({ color = "#808080" }) => {
  return (
    <svg 
      width="16" 
      height="16" 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_422_2)">
        <path d="M15.5 5H11L16 12L11 19H15.5L20.5 12L15.5 5Z" fill={color} />
        <path d="M8.5 5H4L9 12L4 19H8.5L13.5 12L8.5 5Z" fill={color} />
      </g>
      <defs>
        <clipPath id="clip0_422_2">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default LiveUnload;